/**
 * Social sharing link builders (REQ-1.11). Pure functions — no network — so the
 * wallet/CV can render share buttons and the API can record `share_events`.
 * LinkedIn uses the "Add to profile" deep-link (full API integration deferred).
 */

export interface ShareCredentialInfo {
  name: string; // credential / achievement name
  issuerName: string;
  /** Public verify URL for this credential. */
  verifyUrl: string;
  /** Short public id, used as the certification id on LinkedIn. */
  publicId: string;
  /** ISO-8601 issue date. */
  issuedAt: string;
}

/**
 * LinkedIn "Add to Licenses & Certifications" deep-link. Opens the member's
 * profile editor prefilled — no API access needed (MVP fallback, ARCHITECTURE §7.8).
 */
export function linkedInAddToProfileUrl(info: ShareCredentialInfo): string {
  const d = new Date(info.issuedAt);
  const params = new URLSearchParams({
    startTask: "CERTIFICATION_NAME",
    name: info.name,
    organizationName: info.issuerName,
    issueYear: String(d.getUTCFullYear()),
    issueMonth: String(d.getUTCMonth() + 1),
    certId: info.publicId,
    certUrl: info.verifyUrl,
  });
  return `https://www.linkedin.com/profile/add?${params.toString()}`;
}

/** Twitter/X share intent. */
export function twitterIntentUrl(info: ShareCredentialInfo): string {
  const params = new URLSearchParams({
    text: `I earned "${info.name}" from ${info.issuerName} 🎓`,
    url: info.verifyUrl,
  });
  return `https://twitter.com/intent/tweet?${params.toString()}`;
}

export const SHARE_CHANNELS = ["linkedin", "twitter", "pdf", "link"] as const;
export type ShareChannel = (typeof SHARE_CHANNELS)[number];
